var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trilateral-flow"},[_c('new-table',{ref:"table",attrs:{"data":_vm.flowrData,"columns":_vm.columns,"pages":_vm.pages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }